import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import PropTypes, { string } from "prop-types";
import PulseLoader from "react-spinners/PulseLoader";
import i18next from "i18next";
import axios from "axios";
import { Button, Image, Anchor } from "hesus-ui-kit";
import { getDateFormat } from "@utils/datePickerUtils";
import removalIcon from "@icons/ic-removal-product.svg";
import supplyIcon from "@icons/ic-supply-product.svg";
import otherIcon from "@icons/ic-lead-type-other.svg";
import {
  DashboardContainerSection,
  GridRow,
  GridSubItem,
  GridSubLabel,
  ButtonWrapper,
} from "../../DashboardView.styled";
import "../../DashboardView.scss";
/**
 * Dashboard enquiries List,
 * Path - /
 * @see See [https://hesusstore.atlassian.net/wiki/spaces/HS/pages/3356295196/Widget+2+-+New+leads+to+process)
 * @component
 */
const DashboardLeadList = (props) => {
  const { t, widgetName, widgetId, userId, countryId } = props;
  const [isLoading, setIsLoading] = useState(true);
  const [requestData, setRequestData] = useState([]);

  const fetchRequestInfo = () => {
    axios
      .get(`/dashboard/${userId}/widgets/${widgetId}?countryId=${countryId}`)
      .then((response) => {
        setIsLoading(false);
        setRequestData(response.data[0]);
      })
      .catch((error) => {});
  };

  useEffect(() => {
    fetchRequestInfo();
  }, []);

  return (
    <DashboardContainerSection className="widget-list">
      {isLoading && (
        <div className="suggestions-list-loading">
          <PulseLoader color="#1bace4" size={15} />
        </div>
      )}
      <GridRow
        borderBottom="2px solid #cccccc"
        padding="0px 0px 5px"
        marginBottom="7px"
      >
        <GridSubItem fontWeight="700" fontStyle="normal" fontSize="20px">
          {t(widgetName)}
        </GridSubItem>
      </GridRow>
      {!isLoading && requestData?.results?.length === 0 && (
        <GridRow marginBottom="10px" column="1fr" gap="1%">
          <GridSubItem
            fontStyle="normal"
            fontSize="16px"
            color="#474747"
            textAlign="center"
          >
            {t("NO_DATA")}
          </GridSubItem>
        </GridRow>
      )}
      {!isLoading && requestData?.results?.length > 0 && (
        <>
          <GridRow marginBottom="10px" column="10% 51% 18% 18%" gap="1%">
            <GridSubItem fontStyle="normal" fontSize="14px" color="#474747">
              {t("WIDGET_LEAD_SERVICE_TYPE")}
            </GridSubItem>
            <GridSubItem fontStyle="normal" fontSize="14px" color="#474747">
              {t("WIDGET_LEAD_INFORMATION")}
            </GridSubItem>
            <GridSubItem
              fontStyle="normal"
              fontSize="14px"
              color="#474747"
              textAlign="center"
            >
              {t("WIDGET_LEAD_DATE")}
            </GridSubItem>
            <GridSubItem
              fontStyle="normal"
              fontSize="14px"
              color="#474747"
              textAlign="center"
            >
              {t("WIDGET_LEAD_START_DATE")}
            </GridSubItem>
          </GridRow>
          {requestData.results.map((request, requestIndex) => {
            return (
              <GridRow
                key={"dashboard-lead-list-" + request.id + "-" + requestIndex}
                borderBottom={
                  requestIndex + 1 === requestData.results.length
                    ? "0px solid #cccccc"
                    : "1px solid #cccccc"
                }
                column="10% 51% 18% 18%"
                gap="1%"
                padding="5px 0px"
              >
                <GridSubLabel
                  fontWeight="700"
                  fontStyle="normal"
                  fontSize="20px"
                >
                  {request?.serviceType === "DELIVERY" && (
                    <Image
                      className="dashboard-widget-view-site__image_view_icon"
                      src={removalIcon}
                      alt={t("ENQUIRY_SERVICE_TYPE_SUPPLY")}
                      title={t("ENQUIRY_SERVICE_TYPE_SUPPLY")}
                    />
                  )}
                  {request?.serviceType === "EVACUATION" && (
                    <Image
                      className="dashboard-widget-view-site__image_view_icon"
                      src={supplyIcon}
                      alt={t("ENQUIRY_SERVICE_TYPE_REMOVAL")}
                      title={t("ENQUIRY_SERVICE_TYPE_REMOVAL")}
                    />
                  )}
                  {["EVACUATION", "DELIVERY"].indexOf(request?.serviceType) ===
                    -1 && (
                    <Image
                      className="dashboard-widget-view-site__image_view_icon"
                      src={otherIcon}
                      alt={t("ENQUIRY_SERVICE_TYPE_OTHER")}
                      title={t("ENQUIRY_SERVICE_TYPE_OTHER")}
                    />
                  )}
                </GridSubLabel>
                <GridSubItem>
                  <GridRow>
                    <GridSubItem
                      fontWeight="700"
                      fontStyle="normal"
                      fontSize="16px"
                    >
                      <Anchor
                        url={`/lead/view/${request.id}`}
                        className="dashboard-widget-view-site__link"
                        target="_blank"
                      >
                        {"#" + request.id} -{" "}
                        {request.quantity + " " + t(request.unit)}
                        {request.productName
                          ? " - " + request.productName
                          : " - " + t(request.subCategoryName)}
                      </Anchor>
                    </GridSubItem>
                    <GridSubItem fontSize="14px" color="#474747">
                      {request.address.street &&
                      request.address.street !== null &&
                      request.address.street !== "null"
                        ? request.address.street + ", "
                        : ""}
                      {request.address.postalCode
                        ? request.address.postalCode + ", "
                        : ""}
                      {request.address.city}
                    </GridSubItem>
                  </GridRow>
                </GridSubItem>
                <GridSubLabel
                  fontWeight="700"
                  fontStyle="normal"
                  fontSize="16px"
                  textAlign="center"
                  color="#474747"
                >
                  {getDateFormat(request.creationDate, "YYYY-MM-DD")}
                </GridSubLabel>
                <GridSubLabel
                  fontWeight="700"
                  fontStyle="normal"
                  fontSize="16px"
                  textAlign="center"
                  color="#474747"
                >
                  {getDateFormat(request.startDate, "YYYY-MM-DD")}
                </GridSubLabel>
              </GridRow>
            );
          })}
        </>
      )}
      <GridRow>
        <ButtonWrapper>
          <Button
            styles={{
              padding: "5px",
              color: "#00AEEA",
              background: "#fff",
              fontWeight: "700",
              border: "1px solid #00AEEA",
              "&:hover": {
                backgroundColor: "#fff",
              },
            }}
            onClick={() => window.open(`/lead/list`, "_blank")}
          >
            {t("WIDGET_ACTION_SEE_ALL")}
          </Button>
        </ButtonWrapper>
      </GridRow>
    </DashboardContainerSection>
  );
};

DashboardLeadList.propTypes = {
  t: PropTypes.func.isRequired,
  widgetName: PropTypes.string,
  widgetId: PropTypes.number,
  userId: PropTypes.number,
  countryId: PropTypes.number,
};

DashboardLeadList.defaultProps = {
  widgetName: null,
  widgetId: null,
  userId: null,
  countryId: null,
};

export default withTranslation()(DashboardLeadList);
